import userData from "@/plugins/userData";

export default {
  name: "SideBar",
  mixins: [userData],
  data() {
    return {
      link: "dashboard",
      openedMenus: {},
      menuItems: [
        {
          name: "dashboard",
          path: "/dashboard",
          icon: "home",
          label: "Dashboard",
          level: ["admin", "korwil", "korcam", "kordes", "relawan"],
        },
        {
          name: "data-dpt",
          path: "/data-dpt",
          icon: "users",
          label: "Daftar Pemilih Tetap",
          level: ["admin"],
        },
        {
          name: "data-pendukung",
          path: "/data-pendukung",
          icon: "handshake",
          label: "Data Pendukung",
          level: ["admin", "korwil", "korcam", "kordes", "relawan"],
        },
        {
          name: "data-saksi",
          path: "/data-saksi",
          icon: "user-tie",
          label: "Data Saksi",
          level: ["admin", "korwil", "korcam", "kordes"],
        },
        {
          name: "data-relawan",
          path: "/data-relawan",
          icon: "users-cog",
          label: "Data Relawan",
          level: ["admin", "korwil", "korcam", "kordes"],
        },
        {
          name: "rekap-pendukung",
          path: "/rekap/pendukung/",
          icon: "chart-bar",
          label: "Rekap Pendukung",
          level: ["admin", "korwil", "korcam"],
        },
        // {
        //   name: "quick-count",
        //   path: "/quick-count",
        //   icon: "clipboard-list",
        //   label: "Quick Count",
        //   level: ["admin", "kordes", "korcam", "korwil"],
        // },
        {
          name: "master",
          icon: "cogs",
          label: "Master Data",
          level: ["admin", "korwil", "korcam", "kordes"],
          children: [
            {
              name: "master-tim",
              path: "/master/tim/",
              icon: "users",
              label: "Data Tim",
              level: ["admin", "korwil", "korcam", "kordes"],
            },
            {
              name: "master-target",
              path: "/master/target/",
              icon: "bullseye",
              label: "Data Target",
              level: ["admin"],
            },
            {
              name: "master-dapil",
              path: "/master/dapil/",
              icon: "map-marked-alt",
              label: "Data Dapil",
              level: ["admin"],
            },
            {
              name: "pengguna",
              path: "/pengguna",
              icon: "user-shield",
              label: "Pengguna",
              level: ["admin"],
            },
          ],
        },
      ],
    };
  },
  computed: {
    filteredMenuItems() {
      const currentRole = this.userLevel || "user";
      return this.menuItems.filter((item) => item.level.includes(currentRole));
    },
    activeParentMenus() {
      const active = new Set();
      for (const item of this.menuItems) {
        if (item.children) {
          for (const child of item.children) {
            if (this.link === child.name) {
              active.add(item.name);
            }
          }
        }
      }
      return active;
    },
  },
  mounted() {
    // Inisialisasi openedMenus untuk semua menu yang memiliki children
    this.menuItems.forEach((item) => {
      if (item.children) {
        this.openedMenus[item.name] = this.activeParentMenus.has(item.name);
      }
    });

    // Initialize Flowbite untuk dropdown
    this.$nextTick(() => {
      if (window.initFlowbite) {
        window.initFlowbite();
      }
    });
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler(newValue) {
        const pathSegments = newValue.split("/").filter((seg) => seg);
        const pathName =
          pathSegments.length > 0 ? pathSegments[0] : "dashboard";

        // Cek apakah path cocok dengan child menu
        let matchedChildName = null;
        let matchedParentName = null;

        for (const item of this.menuItems) {
          if (item.children) {
            const matchedChild = item.children.find(
              (child) => child.path === newValue,
            );
            if (matchedChild) {
              matchedChildName = matchedChild.name;
              matchedParentName = item.name;
              break;
            }
          }
        }

        // Tutup semua menu yang memiliki submenu
        for (const key in this.openedMenus) {
          this.openedMenus[key] = false;
        }

        // Buka parent menu jika ada child yang cocok
        if (matchedParentName) {
          this.openedMenus[matchedParentName] = true;
        }

        // Set link ke child name jika ada, atau ke path name
        this.link = matchedChildName || pathName;
        this.closeSidebarOnMobile();
      },
    },
  },
  methods: {
    toggleMenu(menuName) {
      const menuItem = this.menuItems.find((item) => item.name === menuName);

      // Jika menu yang diklik memiliki children (submenu)
      if (menuItem && menuItem.children) {
        const wasOpen = this.openedMenus[menuName];

        // Tutup semua menu yang memiliki submenu
        for (const key in this.openedMenus) {
          this.openedMenus[key] = false;
        }

        // Toggle menu yang diklik
        this.openedMenus[menuName] = !wasOpen;
        this.link = menuName;
      } else {
        // Jika menu tanpa children diklik, tutup semua submenu
        for (const key in this.openedMenus) {
          this.openedMenus[key] = false;
        }
        this.link = menuName;
      }
    },
    closeSidebarOnMobile() {
      // Cek apakah dalam mode mobile (sidebar tersembunyi di desktop)
      const sidebar = document.getElementById("logo-sidebar");
      if (sidebar && window.innerWidth < 640) {
        // 640px = sm breakpoint Tailwind
        sidebar.classList.add("-translate-x-full");

        // Optional: Scroll ke atas halaman dengan smooth
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
  },
};
